/// <reference path='../_all.ts' />

module navigation {
  'use strict';

  export class LoadingInterceptor implements ng.IHttpInterceptor {
    public static $inject = ['$injector', '$q', 'debounce'];

    private static _instance: LoadingInterceptor;

    public static Factory($injector: ng.auto.IInjectorService, $q: ng.IQService, loadingIndicatorService: navigation.LoadingIndicatorService) {
      return LoadingInterceptor._instance = new LoadingInterceptor($injector, $q, loadingIndicatorService);
    }

    constructor(
      private $injector: ng.auto.IInjectorService,
      private $q: ng.IQService,
      private loadingIndicatorService: navigation.LoadingIndicatorService) {
      
    }

    public request = (config: ng.IRequestConfig): ng.IRequestConfig|ng.IPromise<ng.IRequestConfig> => {
      this.loadingIndicatorService.taskStarted();
      return config;
    }

    //public requestError = (rejection: any): any => {
    //  console.log("requestError reported");
    //  return this.$q.reject(rejection);
    //}

    public response = <T>(response: ng.IHttpPromiseCallbackArg<T>) : ng.IPromise<ng.IHttpPromiseCallbackArg<T>>|ng.IHttpPromiseCallbackArg<T> => {
      this.loadingIndicatorService.taskEnded();
      return response;
    }

    public responseError = (rejection: any): any => {
      this.loadingIndicatorService.taskEnded();
      return this.$q.reject(rejection);
    }

  }

  LoadingInterceptor.Factory.$inject = ["$injector", "$q", 'loadingIndicatorService'];

}